import {booleanAttribute, Component, input, model} from '@angular/core';
import {AvatarComponent} from '../avatar/avatar.component';

export interface FilterOption<T = string> {
    value: T;
    label: string;
    count?: number | null;
    /** Color of the square dot before the label. */
    color?: string;
    /** Shows an avatar instead of the dot (person chips). */
    avatar?: { name: string; seed?: number | string };
}

/**
 * Pill buttons with dot, label and count. Single select via `[(value)]`,
 * or multi select via `multiple` and `[(values)]`.
 */
@Component({
    selector: 'app-filter-chips',
    imports: [AvatarComponent],
    templateUrl: './filter-chips.component.html',
    styleUrl: './filter-chips.component.scss',
    host: {
        'role': 'group'
    }
})
export class FilterChipsComponent<T = string> {
    readonly options = input<FilterOption<T>[]>([]);
    readonly multiple = input(false, {transform: booleanAttribute});
    readonly value = model<T | null>(null);
    readonly values = model<T[]>([]);

    isActive(value: T): boolean {
        return this.multiple() ? this.values().includes(value) : this.value() === value;
    }

    toggle(value: T) {
        if (this.multiple()) {
            const values = this.values();
            this.values.set(values.includes(value) ? values.filter(v => v !== value) : [...values, value]);
        } else {
            this.value.set(value);
        }
    }
}
